<template>
  <div class="contact-page">
    <!-- Hero Section -->
    <div class="contact-hero">
      <div class="container">
        <div class="hero-terminal">
          <div class="terminal-line">
            <span class="prompt">$</span> ./contact.sh
          </div>
          <h1 class="hero-title">get_in_touch<span class="cursor">_</span></h1>
          <p class="hero-subtitle">Have a question? Let's connect.</p>
        </div>
      </div>
      <div class="hero-bg"></div>
    </div>

    <div class="container py-5">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="terminal-card">
            <div class="terminal-card-header">
              <div class="terminal-dots">
                <span class="terminal-dot red"></span>
                <span class="terminal-dot yellow"></span>
                <span class="terminal-dot green"></span>
              </div>
              <span class="terminal-card-title">~/send_message.sh</span>
            </div>
            <div class="terminal-card-body">
              <div class="form-intro">
                <p><span class="comment"># Fill out this form with any questions you may have</span></p>
                <p><span class="comment"># You can also reach me through socials in the footer</span></p>
                <p><span class="comment"># I will respond as soon as possible</span></p>
              </div>

              <form
                name="contactForm3"
                data-netlify="true"
                netlify-honeypot="bot-field"
                @submit.prevent="submitForm"
                class="terminal-form"
              >
                <input type="hidden" name="form-name" value="contactForm3" />

                <!-- Honeypot anti-spam field -->
                <p style="display:none;">
                  <label>Don't fill this out: <input name="bot-field" /></label>
                </p>

                <div class="form-group">
                  <label for="nameInput" class="form-label">
                    <span class="label-prefix">&gt;</span> name:
                  </label>
                  <input
                    type="text"
                    id="nameInput"
                    name="name"
                    class="terminal-input"
                    placeholder="your_name"
                    required
                  />
                </div>

                <div class="form-group">
                  <label for="emailInput" class="form-label">
                    <span class="label-prefix">&gt;</span> email:
                  </label>
                  <input
                    type="email"
                    id="emailInput"
                    name="email"
                    class="terminal-input"
                    placeholder="your@email.com"
                    required
                  />
                </div>

                <div class="form-group">
                  <label for="message" class="form-label">
                    <span class="label-prefix">&gt;</span> message:
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    class="terminal-input"
                    rows="5"
                    placeholder="Enter your message here..."
                    required
                  ></textarea>
                </div>

                <div class="form-submit">
                  <button type="submit" class="submit-btn">
                    <span class="btn-text">$ send --message</span>
                    <span class="btn-arrow">&rarr;</span>
                  </button>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Success Popup -->
    <div v-if="showSuccessPopup" class="popup-backdrop" @click="closePopup">
      <div class="popup-content terminal-card" @click.stop>
        <div class="terminal-card-header">
          <div class="terminal-dots">
            <span class="terminal-dot red"></span>
            <span class="terminal-dot yellow"></span>
            <span class="terminal-dot green"></span>
          </div>
          <span class="terminal-card-title">success.log</span>
        </div>
        <div class="terminal-card-body text-center">
          <div class="success-icon">[OK]</div>
          <h2 class="success-title">Message Sent!</h2>
          <p class="success-text">Thank you for reaching out. I'll get back to you as soon as possible.</p>
          <p class="success-subtext">// connection established</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ContactView',
  data() {
    return {
      showSuccessPopup: false
    }
  },
  methods: {
    submitForm(event) {
      const form = event.target;
      const formData = new FormData(form);

      fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData).toString()
      })
      .then(() => {
        this.showSuccessPopup = true;
        setTimeout(() => {
          this.showSuccessPopup = false;
        }, 6000);
      })
      .catch((error) => {
        console.error("Form submission error", error);
        alert("Oops! Something went wrong, please try again.");
      });
    },
    closePopup() {
      this.showSuccessPopup = false;
    }
  }
}
</script>

<style scoped>
/* Hero Section */
.contact-hero {
  min-height: 30vh;
  display: flex;
  align-items: center;
  position: relative;
  padding-top: 100px;
}

.hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background:
    radial-gradient(ellipse at 50% 80%, rgba(57, 255, 20, 0.08) 0%, transparent 50%),
    var(--terminal-bg);
  z-index: -1;
}

.hero-terminal {
  font-family: 'JetBrains Mono', monospace;
}

.terminal-line {
  color: var(--terminal-text-dim);
  margin-bottom: 15px;
  font-size: 1rem;
}

.prompt {
  color: var(--terminal-green);
  margin-right: 8px;
}

.hero-title {
  font-size: 3rem;
  color: var(--terminal-text);
  margin-bottom: 15px;
}

.cursor {
  color: var(--terminal-green);
  animation: blink 1s step-end infinite;
}

@keyframes blink {
  0%, 50% { opacity: 1; }
  51%, 100% { opacity: 0; }
}

.hero-subtitle {
  color: var(--terminal-text-dim);
  font-size: 1.1rem;
}


/* Terminal Card */
.terminal-card {
  background: var(--terminal-card-bg);
  border: 1px solid var(--terminal-border);
  border-radius: 8px;
  overflow: hidden;
}

.terminal-card-header {
  background: var(--terminal-bg);
  padding: 10px 15px;
  border-bottom: 1px solid var(--terminal-border);
  display: flex;
  align-items: center;
  gap: 8px;
}

.terminal-dots {
  display: flex;
  gap: 6px;
}

.terminal-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.terminal-dot.red { background: #ff5f56; }
.terminal-dot.yellow { background: #ffbd2e; }
.terminal-dot.green { background: #27c93f; }

.terminal-card-title {
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.8rem;
  color: var(--terminal-text-dim);
  margin-left: 10px;
}

.terminal-card-body {
  padding: 30px;
}


/* Form Styling */
.form-intro {
  margin-bottom: 30px;
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.9rem;
}

.form-intro p {
  margin-bottom: 5px;
}

.comment {
  color: var(--terminal-text-dim);
}

.terminal-form .form-group {
  margin-bottom: 25px;
}

.form-label {
  font-family: 'JetBrains Mono', monospace;
  color: var(--terminal-text);
  font-size: 0.9rem;
  margin-bottom: 10px;
  display: block;
}

.label-prefix {
  color: var(--terminal-green);
  margin-right: 5px;
}

.terminal-input {
  width: 100%;
  background: var(--terminal-bg);
  border: 1px solid var(--terminal-border);
  border-radius: 6px;
  padding: 12px 15px;
  color: var(--terminal-text);
  font-family: 'JetBrains Mono', monospace;
  font-size: 0.95rem;
  transition: all 0.3s ease;
}

.terminal-input::placeholder {
  color: var(--terminal-text-dim);
}

.terminal-input:focus {
  outline: none;
  border-color: var(--terminal-green);
  box-shadow: 0 0 10px rgba(57, 255, 20, 0.2);
}

textarea.terminal-input {
  resize: vertical;
  min-height: 120px;
}


/* Submit Button */
.form-submit {
  margin-top: 30px;
}

.submit-btn {
  width: 100%;
  background: transparent;
  border: 1px solid var(--terminal-green);
  color: var(--terminal-green);
  font-family: 'JetBrains Mono', monospace;
  font-size: 1rem;
  padding: 15px 30px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: all 0.3s ease;
}

.submit-btn:hover {
  background: var(--terminal-green);
  color: var(--terminal-bg);
  box-shadow: 0 0 20px rgba(57, 255, 20, 0.3);
}

.btn-arrow {
  transition: transform 0.3s ease;
}

.submit-btn:hover .btn-arrow {
  transform: translateX(5px);
}


/* Popup */
.popup-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.popup-content {
  max-width: 400px;
  width: 90%;
  animation: popup-scale 0.3s ease-out;
}

.success-icon {
  font-family: 'JetBrains Mono', monospace;
  font-size: 3rem;
  color: var(--terminal-green);
  margin-bottom: 20px;
  animation: glow 2s ease-in-out infinite;
}

@keyframes glow {
  0%, 100% { text-shadow: 0 0 10px var(--terminal-green); }
  50% { text-shadow: 0 0 20px var(--terminal-green), 0 0 30px var(--terminal-green); }
}

.success-title {
  font-family: 'JetBrains Mono', monospace;
  color: var(--terminal-cyan);
  font-size: 1.5rem;
  margin-bottom: 15px;
}

.success-text {
  color: var(--terminal-text);
  margin-bottom: 15px;
}

.success-subtext {
  font-family: 'JetBrains Mono', monospace;
  color: var(--terminal-text-dim);
  font-size: 0.85rem;
}

@keyframes popup-scale {
  from {
    transform: scale(0.8);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}


/* Responsive */
@media (max-width: 768px) {
  .hero-title {
    font-size: 2rem;
  }

  .terminal-card-body {
    padding: 20px;
  }
}
</style>
